import { Building } from './Building';
export class Sand extends Building {
  readonly type = 'sand' as const;
}
